import { FC, useState } from 'react'

import ImageTransport from '../../../transports/common/image-transport'
import { EmblaCarousel } from '../embla-carousel'
import { CarouselContainer } from './styles'
import LazyCarouselSlides from './lazy-carousel-slides'

type Props = {
    images: ImageTransport[]
    imageCarouselBorderRadius?: string
    aspectRatio?: string
    horizontalCardHeight?: string
    imageCarouselMargin?: string
    isAboveFold?: boolean
    imwidth?: number
}

const ImageCarousel: FC<Props> = ({
    images,
    imageCarouselBorderRadius,
    aspectRatio,
    horizontalCardHeight,
    imageCarouselMargin,
    isAboveFold = false,
    imwidth,
}) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

    const slides = images.map((image, index) => (
        <LazyCarouselSlides
            key={image.url}
            images={[image]}
            aspectRatio={aspectRatio}
            horizontalCardHeight={horizontalCardHeight}
            isAboveFold={isAboveFold && index === 0}
            imwidth={imwidth}
            selectedIndex={selectedIndex === index ? 0 : -1}
        />
    ))

    return (
        <CarouselContainer
            horizontalCardHeight={horizontalCardHeight}
            imageCarouselBorderRadius={imageCarouselBorderRadius}
            margin={imageCarouselMargin}
        >
            <EmblaCarousel
                slides={slides}
                loop
                dragEnabled={images.length > 1}
                showDots={images.length > 1}
                dotsVariant="dark"
                showNav={images.length > 1}
                navVariant="dark-overlay"
                onSlideChange={setSelectedIndex}
                viewportPadding="0.1rem 0"
            />
        </CarouselContainer>
    )
}

export default ImageCarousel
